const items = document.querySelectorAll('[data-item-hover]');

// Create hover text element
const hoverText = document.createElement('div');
hoverText.classList.add('hover-text');
document.body.appendChild(hoverText);

// Flag to track scrolling state
let isScrolling;

// Function to initialize hover functionality for an item
function initializeHover(item) {
  const text = item.getAttribute('data-item-hover');
  const media = item.querySelector('img, video'); // Get the media element

  setTimeout(() => {
    item.classList.add('hover-init');
  }, 1000);
  
  if (!media) return; // Skip if no media element found

  media.addEventListener('mouseenter', () => {
    if (!isScrolling) {
      hoverText.textContent = text;
      hoverText.classList.add('active');
    }
  });

  media.addEventListener('mouseleave', () => {
    hoverText.classList.remove('active');
  });

  media.addEventListener('mousemove', (e) => {
    if (!isScrolling) {
      requestAnimationFrame(() => {
        hoverText.style.left = `${e.clientX}px`;
        hoverText.style.top = `${e.clientY}px`;
      });
    }
  });
}

// Initialize hover functionality for all initial items
items.forEach(initializeHover);

// Function to refresh hover functionality for all items
function refreshHoverItems() {
  // Reinitialize hover functionality for all items
  document.querySelectorAll('[data-item-hover]').forEach(item => {
    if (!item.classList.contains('hover-init')) {
      initializeHover(item);
    }
  });
}

// Make the refresh function available globally
window.refreshHoverItems = refreshHoverItems;